import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=50a56678&scoped=true&"
import script from "./BurgerMenu.vue?vue&type=script&lang=js&"
export * from "./BurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=50a56678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a56678",
  null
  
)

export default component.exports